import { type FC } from 'react';

import { useViewportDimensions } from '@/src/components/hooks/useViewportDimensions';

import { EmptyOptionsDisplay } from './EmptyOptionsDisplay';
import { getSearchBarDimensions } from './helpers';
import { LoadingEntriesDisplay } from './LoadingEntriesDisplay';
import { SearchBarAutocomplete } from './SearchBarAutocomplete';
import { SearchBarInput } from './SearchBarInput';
import { SearchBarListbox } from './SearchBarListbox';
import { SearchBarOption } from './SearchBarOption';
import { useSearchBarState } from './useSearchBarState';
import { useSearchQueryData } from './useSearchQueryData';

export const SearchBar: FC = () => {
  const { isSmallViewport } = useViewportDimensions();
  const { isDirty, onInputChange, searchValue } = useSearchBarState();
  const { assignedActivities, fetching } = useSearchQueryData(searchValue);
  const { listboxMinHeight, paperHeight, popperHeight } = getSearchBarDimensions(isSmallViewport);

  const isOpen = isSmallViewport ? true : undefined;

  const ListboxProps = {
    sx: {
      minHeight: listboxMinHeight,
      padding: 1,
    },
  };

  const slotProps = {
    paper: {
      sx: {
        ['.MuiAutocomplete-loading']: { padding: 0 },
        ['.MuiAutocomplete-noOptions']: { padding: 0 },
        height: paperHeight,
      },
    },
    popper: {
      sx: {
        height: popperHeight,
      },
    },
  };

  return (
    <SearchBarAutocomplete
      clearOnBlur={false}
      clearOnEscape={false}
      disableListWrap
      filterOptions={x => x}
      forcePopupIcon={false}
      getOptionLabel={option => option.id}
      ListboxComponent={SearchBarListbox}
      ListboxProps={ListboxProps}
      loading={fetching}
      loadingText={<LoadingEntriesDisplay />}
      noOptionsText={<EmptyOptionsDisplay isDirty={isDirty} />}
      onInputChange={onInputChange}
      open={isOpen}
      openOnFocus
      options={assignedActivities}
      renderInput={SearchBarInput}
      renderOption={({ key, ...props }, option) => (
        <SearchBarOption {...props} key={key} option={option} />
      )}
      slotProps={slotProps}
    />
  );
};
